// ts-prune-ignore-next
export const isNullish = (value: unknown): value is undefined => value == undefined

type Nullish = undefined | null

export const isNotNullish = <A>(value: A | Nullish): value is A => value != undefined
